export default ({ useWrapper, children, wrapper }) => ((useWrapper) ? wrapper(children) : children);
